export type Response<R> = R | (() => R);

export function getResponseValue<R>(response: Response<R>): R {
    return typeof response === 'function' ? (response as () => R)() : response;
}
